<template>
  <div ref="notification" class="columns">
      <div class="column is-full">
          <div class="notification has-text-centered" :class="className">
            {{ text }}
          </div>
      </div>
  </div>
</template>

<script>
export default {
  name: "Notification",
  props: {
    text: String,
    className: String
  },
  mounted()
  {
    setTimeout(() =>
    {
      this.$refs.notification.classList.add("is-hidden");
    }, 6000)
  }
};
</script>